module.exports = __webpack_public_path__ + "img/logo.837479fa.png";